export type ModalId = string & { readonly __modalBrand: unique symbol }

export function defModalId<const L extends string>(literal: L): L & ModalId {
  return literal as L & ModalId
}

export const KnownModalRegistry = {
  LOADING: defModalId("Loading"),
  RETURN_DETAILS: defModalId("ReturnDetails"),
  PHYSICAL_GIFT_CARD: defModalId("PhysicalGiftCard"),
  REMOVE_ITEM_SET: defModalId("RemoveItemSet"),
} as const
